var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4002 0.600098C22.9348 0.600098 25.8002 3.46548 25.8002 7.0001C25.8002 10.4276 23.1058 13.2258 19.7196 13.3923L19.4002 13.4001H16.2002C15.5375 13.4001 15.0002 12.8628 15.0002 12.2001C15.0002 11.5926 15.4516 11.0905 16.0374 11.0111L16.2002 11.0001H19.4002C21.6093 11.0001 23.4002 9.20924 23.4002 7.0001C23.4002 4.87932 21.7497 3.14404 19.6632 3.00861L19.4002 3.0001H16.2002C15.5375 3.0001 15.0002 2.46284 15.0002 1.8001C15.0002 1.19258 15.4516 0.690512 16.0374 0.611052L16.2002 0.600098H19.4002ZM9.8002 0.600098C10.4629 0.600098 11.0002 1.13736 11.0002 1.8001C11.0002 2.40761 10.5487 2.90968 9.96303 2.98914L9.8002 3.0001H6.6002C4.39106 3.0001 2.6002 4.79096 2.6002 7.0001C2.6002 9.12087 4.25065 10.8562 6.33719 10.9916L6.6002 11.0001H9.8002C10.4629 11.0001 11.0002 11.5374 11.0002 12.2001C11.0002 12.8076 10.5487 13.3097 9.96303 13.3891L9.8002 13.4001H6.6002C3.06557 13.4001 0.200195 10.5347 0.200195 7.0001C0.200195 3.57258 2.89455 0.774371 6.28077 0.60793L6.6002 0.600098H9.8002ZM7.0002 5.8001H19.0002C19.6629 5.8001 20.2002 6.33736 20.2002 7.0001C20.2002 7.60761 19.7487 8.10968 19.163 8.18914L19.0002 8.2001H7.0002C6.33745 8.2001 5.8002 7.66284 5.8002 7.0001C5.8002 6.39258 6.25164 5.89051 6.83736 5.81105L7.0002 5.8001H19.0002H7.0002Z",
    fill: "url(#paint0_linear_1441_72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1441_72",
    x1: 13.0002,
    y1: 0.600098,
    x2: 13.0002,
    y2: 13.4001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293744"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPic);
export default __webpack_public_path__ + "static/media/link-pic.9232affb.svg";
export { ForwardRef as ReactComponent };